export const anchorCss = {
  width: "176px",
  padding: "1rem 2rem",
  whiteSpace: "nowrap",
};
